/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../components/page-skeleton/PageHeader";
import { Divider } from "../../../components/Divider";
import { ButtonInternalLink } from "../../../components/NewButtons";
import { AdyenAccountHolderListItem } from "../models/adyen-account-holder";
import { CardBody } from "../../../components/page-skeleton/CardBody";
import { EmptyState } from "../../../components/EmptyState";
import { css } from "@emotion/react";
import { AdyenAccountHoldersTable } from "./AdyenAccountHoldersTable";
import { PageFooter } from "../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../assets/typography/typography";
import { routes } from "../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

type Props = {
  accountHolders: AdyenAccountHolderListItem[];
};

export const AdyenAccountHoldersList = ({ accountHolders }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  return (
    <CardContainer>
      <PageHeader
        title="Account holders"
        subtitle="Manage all of your Adyen account holders"
      >
        <ButtonInternalLink
          to={routes.adyenAccountHolderNew(organizationKeyName)}
        >
          Create new account holder
        </ButtonInternalLink>
      </PageHeader>
      {accountHolders.length === 0 ? (
        <>
          <Divider />
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No account holders created yet"
              subtitle="Click in the top right corner to create your first new account holder."
            />
          </CardBody>
        </>
      ) : (
        <div>
          <AdyenAccountHoldersTable accountHolders={accountHolders} />
          <PageFooter>
            <StyledText className="bodyTextRegular mb-0">
              {accountHolders.length}{" "}
              {accountHolders.length === 1
                ? "account holder"
                : "account holders"}{" "}
              in total
            </StyledText>
          </PageFooter>
        </div>
      )}
    </CardContainer>
  );
};
